import type { TicketCategory, TicketPriority, TicketStatus } from '@services/tickets/types'

export const TICKET_STATUS_TONE: Record<TicketStatus, string> = {
  NEW: 'bg-primary/15 text-primary',
  IN_PROGRESS: 'bg-peach/30 text-warning',
  RESOLVED: 'bg-success-soft text-success',
  CLOSED: 'bg-ink/[0.07] text-ink/60'
}

export const TICKET_PRIORITY_TONE: Record<TicketPriority, string> = {
  LOW: 'bg-ink/[0.07] text-ink/60',
  NORMAL: 'bg-primary/15 text-primary',
  URGENT: 'bg-destructive/15 text-destructive'
}

export const TICKET_CATEGORIES: TicketCategory[] = [
  'WATER_HEATING',
  'ELECTRICITY',
  'APPLIANCES',
  'LOCKS_KEYS',
  'INTERNET',
  'OTHER'
]

export const TICKET_PRIORITIES: TicketPriority[] = ['LOW', 'NORMAL', 'URGENT']

export const TICKET_STATUSES: TicketStatus[] = [
  'NEW',
  'IN_PROGRESS',
  'RESOLVED',
  'CLOSED'
]
